import React, { useEffect } from "react";
import styled from "styled-components";
import { motion, useScroll, useTransform } from "framer-motion";
import AboutMeComp from "../components/homeComponents/AboutMe";
import AboutMe2 from "../components/homeComponents/AboutMe2";
import img1 from "../assets/schulungen/schu4.JPEG";
import img2 from "../assets/homeAssets/aboutMe2.JPG";
import { Link } from "react-router-dom";

// --- Styled Components ---

const PageWrapper = styled.div`
  /* background-color: #f4efed; */
  overflow-x: hidden;
  color: #1a1a1a;
`;

const Section = styled.section`
  padding: 150px 5%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
`;

const DecorativeText = styled.div`
  position: absolute;
  font-family: "Lovelace", serif;
  font-size: 15vw;
  color: rgba(0, 0, 0, 0.973);
  z-index: 0;
  white-space: nowrap;
  pointer-events: none;
`;

// --- 1. THE HERO (Enhanced) ---
const HeroContainer = styled.div`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
`;

const NameOverlay = styled(motion.h1)`
  font-family: "Lovelace", serif;
  font-size: clamp(5rem, 20vw, 15rem);
  line-height: 0.8;
  z-index: 2;
  text-align: center;
  mix-blend-mode: difference;
  color: #e4dfd7;
`;

// --- 2. PHILOSOPHY (Content Heavy) ---
const SplitContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 100px;
  max-width: 1200px;
  align-items: center;

  @media (max-width: 968px) {
    grid-template-columns: 1fr;
    gap: 50px;
  }
`;

const TextBlock = styled(motion.div)`
  display: flex;
  flex-direction: column;
  gap: 30px;

  h2 {
    font-family: "Lovelace", serif;
    font-style: italic;
    font-size: 4rem;
    line-height: 1;
    color: #4a3a3d;
    @media (max-width: 500px) {
      font-size: 2.8em;
    }
  }
  p {
    font-family: "Montserrat", serif;
    font-size: 1.1rem;
    line-height: 1.8;
    color: #a39396;
  }
  .accent-line {
    width: 50px;
    height: 1px;
    background: #a38d92;
  }
`;

// New styled component for the image
const ImageContainer = styled(motion.div)`
  width: 100%;
  height: 700px;
  border-radius: 300px 300px 0 0;
  overflow: hidden;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.1);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
`;

// --- 3. THE VALUES (Grid) ---
const ValuesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  width: 100%;
  max-width: 1200px;
  margin-top: 100px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const ValueCard = styled(motion.div)`
  padding: 40px;
  background: rgba(155, 128, 103, 0.15);
  border-radius: 20px;
  h4 {
    font-family: "Lovelace", serif;
    font-style: italic;
    font-size: 1.8rem;
    margin-bottom: 15px;
  }
  p {
    font-family: "Montserrat", serif;
    font-size: 1rem;
    color: #a38d92;
  }
`;

// --- Component ---

const AboutMe = () => {
  const { scrollYProgress } = useScroll();
  const textX = useTransform(scrollYProgress, [0, 1], [0, -500]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    document.title = "Contact - By Simi";
  }, []);

  return (
    <PageWrapper>
      {/* SECTION 1: HERO
      <HeroContainer>
        <DecorativeText style={{ top: "10%" }}>ESTHÉTIQUE</DecorativeText>
        <NameOverlay
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 1.5, ease: "easeOut" }}
        >
          SIMONA
        </NameOverlay>
        <motion.div
          style={{
            position: "absolute",
            width: "400px",
            height: "600px",
            background: "#dbd4cb",
            zIndex: 1,
          }}
          initial={{ y: 200 }}
          animate={{ y: 0 }}
          transition={{ duration: 1.2, delay: 0.5 }}
        />
      </HeroContainer> */}

      <AboutMe2 />

      {/* SECTION 2: THE STUDIO STORY */}
      <Section>
        <SplitContent>
          <TextBlock
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <div className="accent-line" />
            <motion.span
              style={{
                fontFamily: "Georgia",
                fontStyle: "italic",
                color: "#a38d92",
              }}
            >
              München, Sendling
            </motion.span>
            <h2>Präzision trifft Leidenschaft</h2>
            <p>
              In meinem Behandlungsraum habe ich einen Ort geschaffen, an dem
              Ästhetik und Entspannung verschmelzen. Mit über 5 Jahren Erfahrung
              in der Beauty-Branche ist es mein Ziel, die natürliche Schönheit
              jeder Frau nicht zu verändern, sondern zu unterstreichen.
            </p>
            <p>
              Ob es die perfekte Fächerung bei einer Wimpernverlängerung ist
              oder die sanfte Pigmentierung von Powderbrows – jedes Detail wird
              mit höchster Sorgfalt ausgeführt.
            </p>
          </TextBlock>

          {/* Image Container with animation */}
          <ImageContainer
            whileInView={{ clipPath: ["inset(100% 0 0 0)", "inset(0% 0 0 0)"] }}
            transition={{ duration: 1.5 }}
            initial={{ opacity: 1 }}
            // whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
          >
            <img src={img1} alt="Studio Finas in München Sendling" />
          </ImageContainer>
        </SplitContent>
      </Section>

      {/* SECTION 3: MY PHILOSOPHY */}
      <Section>
        <DecorativeText
          style={{ color: "rgba(143, 115, 115, 0.041)", bottom: "10%" }}
        >
          PHILOSOPHIE
        </DecorativeText>
        <TextBlock
          style={{
            textAlign: "center",
            alignItems: "center",
            maxWidth: "800px",
          }}
        >
          <h2 style={{ color: "#474341" }}>Drei Säulen meiner Arbeit</h2>
          <p style={{ color: "rgba(105, 100, 97, 0.7)" }}>
            Professionalität ist für mich kein Standard, sondern ein
            Versprechen.
          </p>
        </TextBlock>

        <ValuesGrid>
          <ValueCard
            whileHover={{ y: -20 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            <h4>Qualität</h4>
            <p>
              Nur die hochwertigsten Materialien finden den Weg in mein Studio,
              um langanhaltende und gesunde Ergebnisse zu garantieren.
            </p>
          </ValueCard>
          <ValueCard
            whileHover={{ y: -20 }}
            transition={{ type: "spring", stiffness: 300, delay: 0.1 }}
          >
            <h4>Individualität</h4>
            <p>
              Kein Auge ist wie das andere. Ich entwickle für jede Kundin ein
              maßgeschneidertes Mapping, das ihre Gesichtszüge perfekt ergänzt.
            </p>
          </ValueCard>
          <ValueCard
            whileHover={{ y: -20 }}
            transition={{ type: "spring", stiffness: 300, delay: 0.2 }}
          >
            <h4>Weiterbildung</h4>
            <p>
              Die Beauty-Welt schläft nie. Durch ständige Schulungen bleibe ich
              an der Spitze der neuesten Trends wie der Wispy-Technik.
            </p>
          </ValueCard>
        </ValuesGrid>
      </Section>

      {/* SECTION 4: THE ACADEMY VISION */}
      <Section>
        <SplitContent style={{ direction: "rtl" }}>
          <TextBlock
            style={{ direction: "ltr" }}
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <h2>Wissen teilen</h2>
            <p>
              Mein Weg führte mich von der Künstlerin zur Mentorin. In der
              Simona Academy biete ich vier spezialisierte Schulungsarten an:
              von der Einzeltechnik für Anfänger bis hin zur Kombitechnik für
              Profis.
            </p>
            <p>
              Es erfüllt mich mit Stolz, mein Wissen in München-Sendling
              weiterzugeben und Frauen dabei zu helfen, ihr eigenes Business
              erfolgreich aufzubauen.
            </p>
            <Link to={"/schulungen"}>
              <motion.button
                whileHover={{ scale: 1.05 }}
                style={{
                  padding: "20px 40px",
                  background: "#504747",
                  color: "#fff",
                  border: "none",
                  borderRadius: "50px",
                  fontFamily: "Montserrat",
                  cursor: "pointer",
                }}
              >
                Zu den Schulungen
              </motion.button>
            </Link>
          </TextBlock>

          {/* Image Container for Academy section */}
          <ImageContainer
            whileHover={{ scale: 0.98 }}
            transition={{ duration: 0.5 }}
            style={{ borderRadius: "20px" }}
          >
            <img src={img2} alt="Simona Academy Schulungen" />
          </ImageContainer>
        </SplitContent>
      </Section>

      {/* SECTION 5: SIGNATURE */}
      <Section style={{ paddingBottom: "200px" }}>
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 2 }}
          style={{ textAlign: "center" }}
        >
          <p
            style={{
              fontFamily: "Georgia",
              fontStyle: "italic",
              fontSize: "1.5rem",
            }}
          >
            Eure,
          </p>
          <h2
            style={{
              fontFamily: "Lovelace",
              fontStyle: "italic",
              color: "#686262",
              fontSize: "6rem",
              marginTop: "-20px",
            }}
          >
            Simi
          </h2>
        </motion.div>
      </Section>
    </PageWrapper>
  );
};

export default AboutMe;
